export class ApiError extends Error {
  httpStatus: number;

  constructor(message: string, httpStatus: number) {
    super(message);
    this.name = 'ApiError';
    this.httpStatus = httpStatus;
  }
}
